import { request, RespError, handleFormatRes } from '../../utils';
import { EXEC_CHAIN_USERACT } from '../../config/url';
export * from './types';
/**
 *
 * 执行连锁券活动
 *
 * 接口地址：`/app/promotion/prom_combincoup_exec_act.cgi`
 *
 * @param
 * @returns
 */
export async function execChainUseract({ actListid, prizeNo }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            act_listid: actListid,
            prize_no: prizeNo,
        };
        // 接口请求
        const result = await request.get(EXEC_CHAIN_USERACT, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({ result });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
